import gql from 'graphql-tag';

export const typeDefs = gql`
  """
  Basic info about a Webflow Site.
  """
  type SiteInfo {
    """
    The Site id is a Mongo ID, so should be a 24-character hex value.
    """
    id: ID!

    """
    Current (human-readable) name.
    """
    name: String!

    """
    Current slug. Should be alpha-numeric with occasional dashes, so safe to use in URLs. The staging domain for this
    site is \`{slug}.webflow.io\` in production.
    """
    slug: String!

    """
    A timestamp for when this Site was created. (Either via the Dashboard, or using Site import.)
    """
    createdOn: DateTime

    """
    Whether the renderer may send an enforced Content-Security-Policy on this Site's default checkout pages.
    """
    checkoutCspEnforced: Boolean!
  }

  type Query {
    """
    Information about the currently referenced Site.
    """
    siteInfo: SiteInfo!
  }
`;
